import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=840017a2&scoped=true&"
import script from "./VersionList.vue?vue&type=script&lang=js&"
export * from "./VersionList.vue?vue&type=script&lang=js&"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=840017a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840017a2",
  null
  
)

export default component.exports